import React from "react";
import { SlideInFromRight } from "./AnimationLibrary";

const Sidebar = props => {
	if (!props.user || !props.user.netid) {
		return '';
	}
	
	return (
		<div className="sidebar-container">
			<SlideInFromRight delay="0">
				<h2 className="sidebar-heading">Your NetID</h2>
			</SlideInFromRight>
			<SlideInFromRight delay="150">
				<span className="sidebar-subheading">{props.user.netid}</span>
			</SlideInFromRight>
		</div>
	);
};

export default Sidebar;
